export const functor = (v) => {
    return typeof v === "function" ? v : () => v;
};
//# sourceMappingURL=functor.js.map